import moment from 'moment'

export const duration = (date: string) => {
  let momentOne = moment(new Date(date))
  let momentTwo = moment(new Date())
  let result = moment.duration(momentOne.diff(momentTwo))
  return result.humanize()
}
